import { makeVar } from '@apollo/client';
import { UserNode } from 'core/graphql';

/**
 * `UserNode` as the ERP selects it. ТЗ 0074 added two REQUIRED LMS-only
 * counters (`unpaidInvoicesCount` / `overdueInvoicesCount`, 0 for any ERP
 * token) that the ERP never queries; without the Omit every place that stores
 * a fetched user as a full `UserNode` stops type-checking. Runtime-neutral:
 * the ERP must NOT start selecting them (a login query would then fail
 * against a backend without the fields).
 */
export type ErpUserNode = Omit<
  UserNode,
  'unpaidInvoicesCount' | 'overdueInvoicesCount'
>;

export interface IUserState {
  me: ErpUserNode | undefined | null;
}

export const defaultUserState: IUserState = Object.freeze({
  me: undefined,
});

export const userStateVar = makeVar(defaultUserState);
